module.exports = __webpack_public_path__ + "img/form-insta.4246abad.svg";